import { render, staticRenderFns } from "./customRules.vue?vue&type=template&id=eab91652&"
import script from "./customRules.vue?vue&type=script&lang=js&"
export * from "./customRules.vue?vue&type=script&lang=js&"
import style0 from "./customRules.vue?vue&type=style&index=0&id=eab91652&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports